import { render } from "./MessageBoxControl.vue?vue&type=template&id=7feae636"
import script from "./MessageBoxControl.vue?vue&type=script&lang=js"
export * from "./MessageBoxControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__